// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./observeRpcApi";

export let rootObsRpcApi = new Api();
